// Returns the color map for the outfalls
export const getOutfallColor = (value, stormMode, overflowData, LIDMode) => {
    if (stormMode && overflowData) {
        // Define a color scheme based on value ranges
        if (value === 0) return '#666';  // original light yellow
        if (value < 10) return '#a67c52';  // Starker difference
        if (value < 100) return '#b78f6c';  // 
        if (value < 1000) return '#aa775b';  // 
        if (value < 5000) return '#9d5f4a';  // 
        if (value < 10000) return '#A52A2A';  // Red-Brown
        return '#8B0000';  // Dark Red-Brown for the really big overflows 
    } else {
        return '#bcad8f'; // Default color for outfalls
    }
};


// Returns the color map for the subcatchments layer based on the selected color scheme
export const getColorLayer = (colorScheme, selectedFeatureID, LIDMode, LIDContent, devPlanContent) => {

    if (LIDMode && devPlanContent) {
        const layer = {
            id: 'subcatchments',
            type: 'fill',
            paint: {
                'fill-color': [
                    'case',
                    ['has', ['get', 'NAME'], ['literal', devPlanContent]], // WANT TO USE THIS INSTEAD OF LIDContent
                    '#6fff00', // Green color for subcatchments with LID
                    '#ffffff'  // normal color for subcatchments without LID
                ],
                'fill-opacity': [
                    'case',
                    ['==', ['get', 'NAME'], selectedFeatureID],
                    0.9, // Higher opacity for the selected subcatchment
                    0.3  // Lower opacity for others
                ]
            }
        };
        return layer;
    }

        switch (colorScheme) {
            case 'standard':
                return {
                    id: 'subcatchments',
                    type: 'fill',
                    paint: {
                        'fill-color': '#ffffff',
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'NAME'], selectedFeatureID],
                            0.9, // Higher opacity for the selected subcatchment
                            0.3 // Lower opacity for others
                        ]
                    }
                };
            case 'percent_impervious':
                return {
                    id: 'subcatchments',
                    type: 'fill',
                    paint: {
                        'fill-color': [
                            'interpolate',
                            ['linear'],
                            ['get', 'IMPERV'],
                            0, '#008000',
                            20, '#66A266',
                            40, '#B3CDB3',
                            50, '#FFFFFF',
                            60, '#D9BFB3',
                            80, '#A66F66',
                            100, '#663300'
                        ],
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'NAME'], selectedFeatureID],
                            0.9, // Higher opacity for the selected subcatchment
                            0.3  // Lower opacity for others
                        ]
                    }
                };
            case 'elevation':
                return {
                    id: 'subcatchments',
                    type: 'fill',
                    paint: {
                        'fill-color': [
                            'interpolate',
                            ['linear'],
                            ['get', 'WTELEV'],
                            555, '#00008B', // Dark Blue
                            565, '#0000CD', // Medium Blue
                            575, '#0000FF', // Blue
                            585, '#007FFF', // Azure
                            595, '#00FFFF', // Cyan
                            605, '#7FFF00', // Chartreuse
                            615, '#FFFF00', // Yellow
                            625, '#FF7F00', // Orange
                            635, '#FF0000', // Red
                            645, '#8B0000', // Dark Red
                        ],
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'NAME'], selectedFeatureID],
                            0.9, // Higher opacity for the selected subcatchment
                            0.3  // Lower opacity for others
                        ]
                    }
                };
            case 'soil_type':
                return {
                    id: 'subcatchments',
                    type: 'fill',
                    paint: {
                        'fill-color': [
                            'match',
                            ['get', 'AQUIFER'],
                            'Clay', '#A0522D', 
                            'Sand', '#FFA500', 
                            'Loam034', 'violet', 
                            'Loam032', '#FF4500', 
                            'Loam037', 'brown',
                            /* other */ 'white'
                        ],
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'NAME'], selectedFeatureID],
                            0.9, // Higher opacity for the selected subcatchment
                            0.3  // Lower opacity for others
                        ]
                    }
                };
            case 'drawdown':
                return {
                    id: 'subcatchments',
                    type: 'fill',
                    paint: {
                        'fill-color': [
                            'interpolate',
                            ['linear'],
                            ['get', 'DECAY_CONSTANT_ESTIMATE'],
                            -0.28, '#fcfdbf',
                            -0.26, '#fed698',
                            -0.24, '#feaf78',
                            -0.22, '#fb8761',
                            -0.2, '#f1605d',
                            -0.18, '#d7456c',
                            -0.16, '#b6377a',
                            -0.14, '#932b81',
                            -0.12, '#721f81',
                            -0.1, '#50127b',
                            -0.08, '#2d115f',
                            -0.06, '#0f0c2e',
                            0, '#000004',                        
                            // /* other */ 'white'
                        ],
                        'fill-opacity': [
                            'case',
                            ['==', ['get', 'NAME'], selectedFeatureID],
                            0.9, // Higher opacity for the selected subcatchment
                            0.3  // Lower opacity for others
                        ]
                    }
                };
            default:
                return {};
        }
    };